import React, { Component } from 'react';
import fire from '../fire';
import _ from 'lodash';
import { Grid, Form } from 'semantic-ui-react';

class AddYearOneProgram extends Component {
  constructor(props) {
    super(props);
    this.state = {
      weekNumber:"",
      weekDescription: "",
      numOfDays:0,
      days:[]
    };
  }

  postProgram = () => {
    const yearOneProgramRef = fire.database().ref('yearOneProgram');

    const item = {
      weekNumber:this.state.weekNumber,
      weekDescription: this.state.weekDescription,
      days: this.state.days
    }

    yearOneProgramRef.push(item);

    this.setState({
      weekNumber:"",
      weekDescription: "",
      numOfDays: 0,
      days:[]
    });
  }

  handleChange = (e, { name, value }) => {
    this.setState({ 
      [name]: value
    })
  }

  handleChangeArray = (e, { name, value, index }) => {
    let days = [...this.state.days];
  
    let day = {
      ...days[index],
      [name]: value
    }
    
    days[index] = day;
    this.setState({ days }); 
  }


  render() {
    const options = [
      { key: '1', text: '1', value: 1 },
      { key: '2', text: '2', value: 2 },
      { key: '3', text: '3', value: 3 },
      { key: '4', text: '4', value: 4 },
      { key: '5', text: '5', value: 5 },
      { key: '6', text: '6', value: 6 },
      { key: '7', text: '7', value: 7 }
    ]
    return (
      <Grid>
        <Grid.Column>
          <Form onSubmit={this.postProgram}>
            <Form.Group widths='equal'>
              <Form.Input name="weekNumber" type="text" value={this.state.weekNumber} placeholder='Enter the Week Number' onChange={this.handleChange}/>
              <Form.Input name="weekDescription" type="text" value={this.state.weekDescription} placeholder='Enter the Week Description' onChange={this.handleChange}/>
              <Form.Select fluid name="numOfDays" options={options} placeholder='# of Days' onChange={this.handleChange} />
            </Form.Group>
              {
                _.times(this.state.numOfDays, (index) =>
                  <Form.Group key={index}> 
                    <Form.Input index={index} name="dayNumber" type="text" value={this.state.days[index] !== undefined ? this.state.days[index].dayNumber : ''} placeholder='Enter the Day Number' onChange={this.handleChangeArray}/>
                    <Form.Input index={index} name="dayDescription" type="text" value={this.state.days[index] !== undefined ? this.state.days[index].dayDescription : ''} placeholder='Enter the Day Description' onChange={this.handleChangeArray}/>
                  </Form.Group>
                )
              }
            <Form.Group> 
              <Form.Button content='Submit' />
            </Form.Group>
          </Form>
        </Grid.Column>
      </Grid>
    );
  }
}
export default AddYearOneProgram;
